import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from '@ff-os/shared-react/components/dropdown/Dropdown';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectFontFamilyNameById } from '../../_redux';
import { FontFamilyOptionList } from './FontFamilyOptionList';
import { FontFamilyPreview } from './FontFamilyPreview';
import styles from './FontFamilyDropdown.module.scss';

const _FontFamilyDropdown = ({ selectedFontFamily, variableIds }: Props) => (
    <Dropdown
        fieldClassName={styles.field}
        renderPreview={() => <FontFamilyPreview fontFamily={selectedFontFamily} />}>
        <FontFamilyOptionList variableIds={variableIds} />
    </Dropdown>
);

type Props = {
    variableIds: string[];
    selectedFontFamily: string;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    selectedFontFamily: selectFontFamilyNameById(state, ownProps.variableIds[0]!)!
});

export const FontFamilyDropdown = connect(
    mapStateToProps
)(_FontFamilyDropdown);